import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDateRangePicker } from '@mui/x-date-pickers-pro/MobileDateRangePicker';
import DateRangeInput from './DateRangeInput';
import DateRangeChip from './DateRangeChip';
import { DateRangePickerContainer } from '../DateRanges.styles';
import dayjs, { Dayjs } from 'dayjs';
import { shortcutsItems } from '../DateRanges.utils';
import { useDateRange } from '../DateRanges.context';
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

const CustomDateRangePicker = ({ showAsChip }: { showAsChip?: boolean }) => {
  const { setDateRange, dateRange } = useDateRange();

  return (
    <DateRangePickerContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDateRangePicker<Dayjs>
          value={dateRange}
          maxDate={dayjs()}
          // calendars={1}
          timezone='UTC'
          onAccept={newValue => setDateRange(newValue as [Dayjs, Dayjs])}
          slots={{ field: showAsChip ? DateRangeChip : DateRangeInput }}
          slotProps={{
            shortcuts: {
              items: showAsChip ? undefined : shortcutsItems,
            },
            actionBar: {
              hidden: true,
              actions: ['cancel', 'accept'],
              sx: {
                button: {
                  color: 'white.main',
                },
              },
            },
          }}
          sx={{
            gridRow: 2,
            gridColumn: 1,
          }}
          closeOnSelect
        />
      </LocalizationProvider>
    </DateRangePickerContainer>
  );
};

export default CustomDateRangePicker;
